export interface OpcionGraficaBsc {
  id: string;
  etiqueta: string;
  visible: boolean;
}

const CLAVE = "bsc.tablero.graficas-for011.v1";

export function opcionesGraficas(): OpcionGraficaBsc[] {
  const opciones = [
    { id: "cumplimiento", etiqueta: "Cumplimiento por área", visible: true },
    { id: "anual", etiqueta: "Promedio anual", visible: true },
    { id: "trimestres", etiqueta: "Alcance por trimestre", visible: true },
    { id: "gerencial", etiqueta: "Estatus gerencial", visible: true },
    { id: "areas", etiqueta: "Alcance al corte por área", visible: true },
  ];
  try {
    const ocultas: unknown = JSON.parse(localStorage.getItem(CLAVE) ?? "[]");
    if (Array.isArray(ocultas)) {
      opciones.forEach((opcion) => { opcion.visible = !ocultas.includes(opcion.id); });
    }
  } catch {
    // Si el almacenamiento no está disponible, se mantienen las opciones iniciales.
  }
  return opciones;
}

export function guardarGraficas(opciones: OpcionGraficaBsc[]): void {
  try {
    localStorage.setItem(CLAVE, JSON.stringify(opciones.filter((opcion) => !opcion.visible).map((opcion) => opcion.id)));
  } catch {
    // La selección sigue funcionando durante esta visita aunque no se pueda guardar.
  }
}
